goog.provide('el8.data.letterCategories');

goog.require('el8.service.urls');
goog.require('el8.model.base');


el8.data.letterCategories = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('key', true);
    _class.addStringProperty('text', true);
    _class.addStringProperty('role', true);
    _class.addBoolean('providerIncluded', true);

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        key: 'key',
        urlLoad: function () { return el8.service.urls.get('letterCategories'); }
    });

    return that;

})();

